const STORAGE_KEY = 'tamepulse.quoteEntity.pendingForm'
const PATCH_EVENT = 'tamepulse-quote-entity-form-patch'

let pendingPayload = null

const browserSessionStorage = () => {
    try {
        return window?.sessionStorage || null
    } catch (error) {
        return null
    }
}

export const setPendingQuoteEntityForm = (payload) => {
    pendingPayload = payload

    try {
        browserSessionStorage()?.setItem(STORAGE_KEY, JSON.stringify(payload))
    } catch (error) {
        void error
    }
}

export const consumePendingQuoteEntityForm = (entity, key) => {
    let payload = pendingPayload

    if (!payload) {
        try {
            payload = JSON.parse(browserSessionStorage()?.getItem(STORAGE_KEY) || 'null')
        } catch (error) {
            browserSessionStorage()?.removeItem(STORAGE_KEY)
            return null
        }
    }

    if (payload?.entity !== entity || !payload.form || typeof payload.form !== 'object') {
        return null
    }

    if (!key || (payload.key && String(payload.key) !== String(key))) {
        return null
    }

    pendingPayload = null
    browserSessionStorage()?.removeItem(STORAGE_KEY)

    return payload
}

const isPlainObject = (value) => (
    value !== null
    && typeof value === 'object'
    && !Array.isArray(value)
)

export const mergeQuoteEntityFormPatch = (base, patch) => {
    const output = structuredClone(base || {})
    const input = patch && typeof patch === 'object' ? patch : {}

    Object.entries(input).forEach(([key, value]) => {
        if (isPlainObject(value) && isPlainObject(output[key])) {
            output[key] = mergeQuoteEntityFormPatch(output[key], value)
            return
        }

        output[key] = structuredClone(value)
    })

    return output
}

export const applyQuoteEntityFormPatch = (payload) => {
    const detail = {
        ...payload,
        applied: false,
    }

    try {
        window.dispatchEvent(new CustomEvent(PATCH_EVENT, { detail }))
    } catch (error) {
        void error
    }

    return detail.applied
}

export const listenQuoteEntityFormPatch = (entity, callback) => {
    const listener = (event) => {
        const detail = event.detail || {}

        if (detail.entity !== entity || !detail.form || typeof detail.form !== 'object') {
            return
        }

        callback(detail)
        detail.applied = true
    }

    window.addEventListener(PATCH_EVENT, listener)

    return () => window.removeEventListener(PATCH_EVENT, listener)
}
